import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

var Container = function Container(props) {
  var containerClass = classNames('container', props.className);
  return React.createElement("div", {
    className: containerClass
  }, props.children);
};

Container.propTypes = {
  className: PropTypes.string
};
Container.defaultProps = {
  className: ''
};
Container.displayName = 'Container';
export default React.memo(Container);